import Banner from '../banner/Banner';
import MainNavigation from './MainNavigation';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

function ContentWrapper(props) {
    const location = useLocation();
    const [showBanner, setShowBanner] = useState(true);

    useEffect(() => {
        const showBannerValue = location.pathname === '/about' ? false : true;
        setShowBanner(showBannerValue);
    }, [location.pathname]);

    return (
        <div>
            <MainNavigation />
            {showBanner && <Banner />}
            <main className="p-4 sm:p-10">{props.children}</main>
        </div>
    )
}

export default ContentWrapper;